module.exports = __webpack_public_path__ + "static/img/01.a047ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/01.jpg
// module id = Tx2E
// module chunks = 0